import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
interface ProgramCardProps {
  title: string;
  who: string;
  what: string;
  image: string;
  link: string;
  ctaText: string;
  color: 'blue' | 'orange';
}
export const ProgramCard: React.FC<ProgramCardProps> = ({
  title,
  who,
  what,
  image,
  link,
  ctaText,
  color
}) => {
  const colorClasses = {
    blue: {
      bg: 'bg-[#F2F0E7]',
      text: 'text-[#3AB5E8]',
      button: 'primary',
      border: 'border-[#3AB5E8]/20'
    },
    orange: {
      bg: 'bg-[#F2F0E7]',
      text: 'text-[#FC963E]',
      button: 'secondary',
      border: 'border-[#FC963E]/20'
    }
  };
  const theme = colorClasses[color];
  return <motion.div whileHover={{
    y: -8
  }} className={`bg-white rounded-3xl overflow-hidden shadow-lg border-2 ${theme.border} flex flex-col h-full`} data-id="element-162">
      <div className="h-48 overflow-hidden" data-id="element-163">
        <img src={image} alt={title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-164" />
      </div>

      <div className="p-8 flex flex-col flex-grow" data-id="element-165">
        <h3 className="text-3xl font-bold text-[#1C274C] mb-6" data-id="element-166">{title}</h3>

        <div className="space-y-4 mb-8 flex-grow" data-id="element-167">
          <div data-id="element-168">
            <span className={`text-xs font-bold uppercase tracking-wider ${theme.text} bg-white border border-current px-2 py-1 rounded-md`} data-id="element-169">
              Who it's for
            </span>
            <p className="mt-2 text-gray-700 font-medium text-lg" data-id="element-170">{who}</p>
          </div>

          <div data-id="element-171">
            <span className={`text-xs font-bold uppercase tracking-wider ${theme.text} bg-white border border-current px-2 py-1 rounded-md`} data-id="element-172">
              What you'll learn
            </span>
            <p className="mt-2 text-gray-600" data-id="element-173">{what}</p>
          </div>
        </div>

        <Link to={link} className="block w-full" data-id="element-174">
          <Button variant={theme.button as any} size="lg" className="w-full justify-center text-lg font-bold py-6" rightIcon={<ArrowRight className="w-5 h-5" data-id="element-176" />} data-id="element-175">
            {ctaText}
          </Button>
        </Link>
      </div>
    </motion.div>;
};